import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, TooltipProps } from '@ui';

interface Props {
    tooltip: string;
    placement?: TooltipProps['placement'];
}

const InfoTooltip = ({ tooltip, placement }: Props) => (
    <Tooltip tooltipClassName={'tw-max-w-[300px] '} tooltip={tooltip} placement={placement} autoPlacement>
        <FontAwesomeIcon icon={faCircleInfo} className="tw-align-middle tw-text-accents-6" size="sm" />
    </Tooltip>
);

export default InfoTooltip;
